
/* Veluna light-bulb option | draft-theme implementation */
(()=>{
  'use strict';
  const BULB_VARIANT=59734888644940;
  const ROOT=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root)||'/';
  const endpoint=(path)=>(ROOT.endsWith('/')?ROOT.slice(0,-1):ROOT)+path;
  const requests={add:()=>endpoint('/cart/add.js'),change:()=>endpoint('/cart/change.js'),get:()=>endpoint('/cart.js')};
  let pending=false;
  const json=async (url,payload)=>{const r=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload),credentials:'same-origin'});if(!r.ok){let message='Unable to update your cart';try{const b=await r.json();message=b.description||b.message||message}catch(e){}throw Error(message)}return r.json()};
  function productChoice(input){
    const wrap=input.closest('[data-veluna-bulb-product]');if(!wrap)return;
    const form=wrap.closest('form');if(!form)return;
    const pay=form.querySelector('.veluna-dynamic-checkout');
    const note=form.querySelector('.veluna-bulb-choice__notice');
    if(pay)pay.hidden=input.checked;
    if(note)note.hidden=!input.checked;
  }
  document.addEventListener('change',e=>{if(e.target.matches('.veluna-bulb-choice__input'))productChoice(e.target)},true);
  async function addProductAndBulb(form,submitter){
    if(pending)return;
    const data=new FormData(form);
    const id=Number(data.get('id')||form.querySelector('[name=id]')?.value);
    const formId=form.id;
    const externalQty=formId?document.querySelector('input[name="quantity"][form="'+CSS.escape(formId)+'"]'):null;
    const quantity=Math.max(1,Number(data.get('quantity')||externalQty?.value||1));
    if(!id){window.alert('Please select a variant.');return}
    const btn=submitter||form.querySelector('[type=submit]');
    const previous=btn?.disabled;if(btn)btn.disabled=true;
    pending=true;
    try{
      const props={};
      for(const [key,value] of data.entries()){
        if(key.startsWith('properties[')&&key.endsWith(']'))props[key.slice(11,-1)]=String(value);
      }
      const title=form.closest('.product-info')?.querySelector('h1')?.textContent?.trim()||document.querySelector('h1')?.textContent?.trim()||'Light fixture';
      await json(requests.add(),{items:[
        {id,quantity,properties:props},
        {id:BULB_VARIANT,quantity,properties:{'_veluna_parent':String(id),'Paired luminaire':title}}
      ]});
      window.location.assign(endpoint('/cart'));
    }catch(err){
      window.alert('We could not add the bulb: '+err.message);
      pending=false;if(btn)btn.disabled=previous;
    }
  }
  // For opted-in bulbs, use the dependable cart flow. Native wallet buttons
  // remain unchanged and usable when the optional bulb is not selected.
  document.addEventListener('submit',e=>{
    const form=e.target;
    if(!(form instanceof HTMLFormElement))return;
    if(!form.querySelector('.veluna-bulb-choice__input:checked'))return;
    e.preventDefault();e.stopImmediatePropagation();
    void addProductAndBulb(form,e.submitter);
  },true);

  // Shopify Section Rendering API: refresh cart UI without navigating away.
  // Replace content inside the existing drawer custom element to retain its open state.
  async function refreshCartInterface(focusVariant){
    const sectionIds=['cart-drawer','main-cart'];
    const url=endpoint('/?sections='+sectionIds.join(','));
    const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}});
    if(!response.ok)throw Error('Unable to refresh cart display');
    const sections=await response.json();
    const parser=new DOMParser();
    let drawerUpdated=false,mainUpdated=false;
    const drawer=document.querySelector('cart-drawer#cart-drawer');
    if(drawer && typeof sections['cart-drawer']==='string' && sections['cart-drawer'].trim()){
      const doc=parser.parseFromString(sections['cart-drawer'],'text/html');
      const next=doc.querySelector('cart-drawer#cart-drawer');
      if(next){
        const scroll=drawer.querySelector('.cart-drawer__items')?.scrollTop||0;
        drawer.innerHTML=next.innerHTML;
        drawer.classList.toggle('drawer--center-body',next.classList.contains('drawer--center-body'));
        const list=drawer.querySelector('.cart-drawer__items');
        if(list)list.scrollTop=scroll;
        const candidate=Array.from(drawer.querySelectorAll('[data-veluna-bulb-cart]')).find(el=>el.dataset.parentVariant===String(focusVariant));
        if(candidate)candidate.focus({preventScroll:true});
        drawerUpdated=true;
      }
    }
    const main=document.querySelector('.shopify-section--main-cart');
    if(main && typeof sections['main-cart']==='string' && sections['main-cart'].trim()){
      const doc=parser.parseFromString(sections['main-cart'],'text/html');
      const next=doc.querySelector('.shopify-section--main-cart');
      if(next){
        main.innerHTML=next.innerHTML;
        mainUpdated=true;
      }
    }
    // Keep cart counters aligned with server data, including when the drawer stays open.
    const cart=await fetch(requests.get(),{credentials:'same-origin',cache:'no-store'}).then(r=>r.json());
    document.querySelectorAll('[data-veluna-cart-count]').forEach(el=>{el.textContent=String(cart.item_count)});
    document.dispatchEvent(new CustomEvent('veluna:bulb-cart-updated',{detail:{cart}}));
    if((drawer&&!drawerUpdated)||(main&&!mainUpdated))throw Error('Cart saved, but could not refresh the display');
  }

  // Per-luminaire add/remove works in the cart drawer and full cart page.
  document.addEventListener('click',async e=>{
    const button=e.target.closest('[data-veluna-bulb-cart]');
    if(!button)return;
    e.preventDefault();
    if(pending)return;pending=true;button.disabled=true;
    try{
      const parent=String(button.dataset.parentVariant);
      const cart=await fetch(requests.get(),{credentials:'same-origin'}).then(r=>r.json());
      const matched=cart.items.filter(i=>Number(i.id)===BULB_VARIANT&&String(i.properties?._veluna_parent)===parent);
      if(matched.length){
        for(const item of matched){await json(requests.change(),{id:item.key,quantity:0})}
      }else{
        const qty=cart.items.filter(i=>String(i.id)===parent).reduce((n,i)=>n+i.quantity,0);
        if(!qty)throw Error('The light fixture is no longer in your cart.');
        await json(requests.add(),{items:[{id:BULB_VARIANT,quantity:qty,properties:{'_veluna_parent':parent,'Paired luminaire':button.dataset.parentTitle||'Light fixture'}}]});
      }
      await refreshCartInterface(parent);
    }catch(err){window.alert('The cart could not be refreshed. Please reopen the cart if needed. '+err.message);button.disabled=false}
    finally{pending=false}
  },true);
  // Ensure quantities match if shopper changed their main product quantity before checkout.
  async function reconcile(){
    const cart=await fetch(requests.get(),{credentials:'same-origin'}).then(r=>r.json());
    const bases=new Map();
    for(const i of cart.items){if(Number(i.id)!==BULB_VARIANT)bases.set(String(i.id),(bases.get(String(i.id))||0)+i.quantity)}
    let updated=false;
    for(const i of cart.items){if(Number(i.id)!==BULB_VARIANT)continue;const target=bases.get(String(i.properties?._veluna_parent))||0;if(target!==i.quantity){await json(requests.change(),{id:i.key,quantity:target});updated=true}}
    return updated;
  }
  document.addEventListener('submit',async e=>{
    const form=e.target;
    if(!(form instanceof HTMLFormElement)||!form.querySelector('[name=checkout]'))return;
    if(form.dataset.velunaSynced==='true')return;
    e.preventDefault();e.stopImmediatePropagation();
    if(pending)return;pending=true;
    try{await reconcile();form.dataset.velunaSynced='true';form.requestSubmit(e.submitter||form.querySelector('[name=checkout]'))}
    catch(err){pending=false;window.alert('Please check your bulb option: '+err.message)}
  },true);
  // Express wallet buttons on cart should not use an outdated total after quantity adjustments.
})();
